<template>
  <div>
    <el-empty v-if="!proUsers || !proUsers.length" description="暂无项目经历"></el-empty>
    <div v-for="proUser in proUsers" :key="proUser.id" class="pro-user-info-box">
      <el-row justify="space-between">
        <div>
          <div>
            <span>标签：</span>
            <span>{{proUser.label}}</span>
          </div>
          <div style="margin-top:5px;">
            <el-button :type="proUser.statusNum === 1 ? 'success' : 'info'" size="small">{{proUser.statusName}}</el-button>
            <el-button color="#81d3f8" size="small" style="color: white" v-if="isMamanger(proUser)">管理员</el-button>
            <el-button color="#81d3f8" size="small" style="color: white" v-if="proUser.directorId === userId">负责人</el-button>
          </div>
          <span class="entry-time">入群时间：{{proUser.entryTimeString}}</span>
        </div>
        <el-button type="primary" @click="toInfo(proUser)" icon="view">查看详情</el-button>
      </el-row>
    </div>

    <project-info v-model="infoVisible" :userId="userId" :proUser="proUser" />
  </div>
</template>

<script>
import { getProjectUserByUserId } from '@/api/sys/user';
import { defineComponent } from 'vue';
import ProjectInfo from './ProjectInfo.vue';

export default defineComponent({
  components: { ProjectInfo },
  props: {
    userId: String,
    currColumnValue: Number
  },
  data() {
    return {
      infoVisible: false,
      proUsers: [],
      proUser: {}
    }
  },
  methods: {
    getData() {
      getProjectUserByUserId(this.userId).then(({data}) => {
        data.data.forEach(proUser => this.setLabel(proUser))
        this.proUsers = data.data;
      })
    },
    setLabel(proUser) {
      let retString = proUser.orgFullPathName + '/' + proUser.projectFullPathName;
      if (proUser.isTeam === 1) {
        retString += '/' + proUser.teamName;
      }
      if (proUser.isGroup === 1) {
        retString += '/' + proUser.groupName;
      }
      proUser.label = retString.split('/').join(' - ');
    },
    isMamanger(proUser) {
      if (proUser.isGroup === 1) {
        return proUser.isGroupAdministration === 1;
      }
      if (proUser.isTeam === 1) {
        return proUser.isTeamAdministration === 1;
      }
      return proUser.isProjectAdministration === 1;
    },
    toInfo(proUser) {
      this.proUser = proUser;
      this.infoVisible = true;
    }
  },
  watch: {
    currColumnValue(val) {
      if (val === 2) {
        this.getData();
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.pro-user-info-box {
  border-left: 6px solid #24d2d3;
  padding: 15px 15px 5px;
  background-color: #ecf5ff;
  border-radius: 4px;
  & + .pro-user-info-box {
    margin-top: 25px;
  }
  .el-row {
    align-items: center;
    .entry-time {
      display: inline-block;
      color: #999999;
      border: 1px solid #e4e4e4;
      padding: 3px 15px;
      font-size: 12px;
      margin-top: 15px;
    }
  }
}
</style>